import { api } from "../api/client";

// Mock customer profile used in dev when the BFF isn't wired up.
// Mirrors the NetSuite customer fields we read on bootstrap:
//   terms, creditLimit, creditHold, openBalance, unbilledOrders.
const MOCK_CUSTOMER = {
  id: "demo-cust",
  email: "demo@mysteryranch.com",
  firstName: "Demo",
  lastName: "Buyer",
  company: "Demo B2B Account",
  priceLevel: "wholesale",
  terms: "Net 30",
  creditLimit: 25000,
  creditHold: "OFF",
  openBalance: 6420.50,
  unbilledOrders: 2900.00,
};

async function withMock(promise, fallback) {
  try {
    const out = await promise;
    if (out && (out.id || out.user || out.email)) return out;
    return fallback();
  } catch {
    return fallback();
  }
}

export const CustomerController = {
  get() {
    return withMock(api.getAccount(), () => MOCK_CUSTOMER);
  },
  update(patch) { return api.updateAccount(patch); },
  login(email, password) { return api.login(email, password); },
  logout() { return api.logout(); },
  session() {
    return withMock(api.getSession(), () => ({ user: MOCK_CUSTOMER }));
  },
};
